/** @format */

import { useSelector } from "react-redux";
import "../App.css";
import React, { useEffect, useState } from "react";
import DatosPersonales from "../Components/DatosPersonales/DatosPersonales";
import DatosFiscales from "../Components/DatosPersonales/DatosFiscales";

const Datos = () => {
  const user = useSelector((state) => state.user.id); // Obtener el ID del usuario
  const path = useSelector((state) => state.sitePath);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isActive, setIsActive] = useState("personales");
  const [formDataEstados, setFormDataEstados] = useState([]);
  const [formDataPaises, setFormDataPaises] = useState([]);
  const [formDataRegimenes, setFormDataRegimenes] = useState([]);
  const [formData, setFormData] = useState({
    nombres: "",
    apellido_paterno: "",
    apellido_materno: "",
    fecha_nacimiento: "",
    genero: "",
    estado_nacimiento: "",
    nacionalidad: "",
    pais: "",
    curp: "",
    mail: "",
    celular: "",
    razon_social: "",
    rfc: "",
    regimen: "",
    constancia: null,
    calle: "",
    numero_ext: "",
    colonia: "",
    cp: "",
    ciudad: "",
  });

  const fetchAlumnoData = async () => {
    const url = `${path}/datos_alumno.php?id_alumno=${user}&get_estados=1&get_paises=1&get_regimenes=1`;

    try {
      setLoading(true);
      setError(null);

      const response = await fetch(url, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`Error en la petición: ${response.statusText}`);
      }

      const data = await response.json();
      console.log(data);
      setFormData(data.data_alumno);
      setFormDataEstados(data.data.data_estados);
      setFormDataPaises(data.data.data_paises);
      setFormDataRegimenes(data.data.data_regimenes);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchAlumnoData();
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let dataToSubmit;
    if (isActive === "personales") {
      const {
        nombres,
        apellido_paterno,
        apellido_materno,
        fecha_nacimiento,
        genero,
        estado_nacimiento,
        nacionalidad,
        pais,
        curp,
        mail,
        celular,
        personal,
      } = formData;

      // Aquí verificamos si alguno de los valores es nulo o undefined, y lo tratamos adecuadamente
      dataToSubmit = {
        nombres: nombres || "", // Si nombres es null o undefined, lo convertimos a una cadena vacía
        apellido_paterno: apellido_paterno || "",
        apellido_materno: apellido_materno || "",
        fecha_nacimiento: fecha_nacimiento || "", // O cualquier valor por defecto que desees
        genero: genero || "",
        estado_nacimiento: estado_nacimiento || "", //
        nacionalidad: nacionalidad || "",
        pais: pais || "",
        curp: curp || "",
        mail: mail || "",
        celular: celular || "",
        user: user,
        id: user,
        personal: 1,
      };
    } else if (isActive === "fiscales") {
      const {
        razon_social,
        rfc,
        regimen,
        constancia,
        calle,
        numero_ext,
        colonia,
        cp,
        ciudad,
        estado_nacimiento,
      } = formData;

      dataToSubmit = {
        razon_social: razon_social || "",
        rfc: rfc || "",
        regimen: regimen || "",
        constancia: constancia || null,
        calle: calle || "",
        numero_ext: numero_ext || "",
        colonia: colonia || "",
        cp: cp || "",
        ciudad: ciudad || "",
        estado_nacimiento: estado_nacimiento || "",
        user: user,
        id: user,
      };
    }

    try {
      const formDataToSend = new FormData();
      Object.entries(dataToSubmit).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch(`${path}/submit_data.php`, {
        method: "POST",
        body: formDataToSend,
      });

      if (!response.ok) {
        throw new Error("Error al enviar los datos.");
      } else {
        alert("Datos enviados con éxito.");
      }
    } catch (error) {
      console.error(error);
      alert("Hubo un problema al enviar los datos.");
    }
  };

  return (
    <section
      id='new-alumno'
      className='section'
    >
      <div className='container'>
        {loading && <p>Cargando datos...</p>}
        {error && <p>Error: {error}</p>}

        <form
          id='registration-form'
          className='formulario-inscripcion'
          onSubmit={handleSubmit}
        >
          <div className='opciones-formulario'>
            <ul className='nav mb-5'>
              <li className='nav-item'>
                <button
                  type='button'
                  className={`btn mx-2 ${
                    isActive === "personales" ? "btn-primary" : "btn-light"
                  }`}
                  onClick={() => setIsActive("personales")}
                >
                  Datos personales
                </button>
              </li>
              <li className='nav-item'>
                <button
                  type='button'
                  className={`btn mx-2 ${
                    isActive === "fiscales" ? "btn-primary" : "btn-light"
                  }`}
                  onClick={() => setIsActive("fiscales")}
                >
                  Datos Fiscales
                </button>
              </li>
            </ul>
          </div>

          {isActive === "personales" && (
            <DatosPersonales
              formData={formData}
              formDataEstados={formDataEstados}
              formDataPaises={formDataPaises}
              handleChange={handleChange}
            />
          )}

          {isActive === "fiscales" && (
            <DatosFiscales
              formData={formData}
              handleChange={handleChange}
              formDataRegimenes={formDataRegimenes}
            />
          )}

          <div
            id='btn-content'
            className='d-flex justify-content-center mt-4'
          >
            <button
              type='submit'
              className='btn btn-success'
            >
              Enviar
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Datos;
